<template>
  <div class="d-flex flex-column min-vh-100">
    <Navbar />
    <main class="flex-grow-1">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <Footer />
    <CookieBanner @cookies-accepted="handleCookieConsent" />
  </div>
</template>

<script>
import Navbar from '@/components/layout/Navbar.vue'
import Footer from '@/components/layout/Footer.vue'
import CookieBanner from '@/components/home/CookieBanner.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    CookieBanner
  },
  methods: {
    handleCookieConsent(level) {
      console.log('Cookie consent level:', level)
      if (level === 'all') {
        console.log('Inizializzazione servizi analytics')
      }
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

main {
  padding-top: 55px; /* Aumentato per dare più spazio */
}

footer {
  margin-top: auto;
}

/* Stili globali per i link nel footer */
footer a {
  text-decoration: none;
  transition: opacity 0.3s ease;
}

footer a:hover {
  opacity: 0.8;
}
</style>
